
import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import AppraisalFormComponent from '../AppraisalFormComponent';
import FileUploadWithPreview from '../FileUploadWithPreview';
import EmployeePMSRating from '../EmployeePMSRating';
import RatingTable from '../RatingTable/RatingTable';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast, ToastContainer } from 'react-toastify';
import TeamPMSRating from './DepartmentPMSRating';
import RejectCommendModal from '../../../../Components/RejectCommandModal/RejectCommendModal';
import { MarkAsUnread } from '@mui/icons-material';
import DepartmentPMSRating from './DepartmentPMSRating';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';


// const getRating = (value) => {
//     if (value >= 96 && value <= 100) {
//         return 'OUTSTANDING (O)';
//     } else if (value >= 80 && value <= 95) {
//         return 'MEETS ALL EXPECTATIONS (MAE)';
//     } else if (value >= 61 && value <= 79) {
//         return 'MEETS MOST EXPECTATIONS (MME)';
//     } else {
//         return 'BELOW EXPECTATION (BE)';
//     }
// };
// const getRating = (score) => {
//     if (score === '') return '';
//     if (score > 100) return '';
//     if (score >= 96) return 'OUTSTANDING';
//     if (score >= 80) return 'MEETS ALL EXPECTATIONS';
//     if (score >= 61) return 'MEETS MOST EXPECTATIONS';
//     if (score >= 1) return 'BELOW EXPECTATION';

//     // return 'BELOW EXPECTATION (BE)';
// };
const getRating = (value) => {
    if (value === null || value === "") return "";

    value = Number(value); // force numeric
    if (value >= 96 && value <= 100) {
        return 'OUTSTANDING';
    } else if (value >= 80 && value <= 95) {
        return 'MEETS ALL EXPECTATIONS';
    } else if (value >= 61 && value <= 79) {
        return 'MEETS MOST EXPECTATIONS';
    } else {
        return 'BELOW EXPECTATION';
    }
};

const DepartmentAppraisalForm = () => {
    const [comments, setComments] = useState('');
    const [appraisalData, setAppraisalData] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [questionSectionData, setQuestionSectionData] = useState([])
    const [responseApiData, setResponseApiData] = useState([])
    console.log('responseApiData', responseApiData);
    const { getKraKpiAppraisalForm } = useSelector((state) => state?.getKraKpiAppraisalForm);
    console.log(getKraKpiAppraisalForm, "getKraKpiAppraisalForm")
    const [isRejectCommandModalOpen, setRejectCommandModalOpen] = useState()
    const [reviewerScore, setReviewerScore] = useState('');

    const handleRejectCommandOpenModal = () => {
        setRejectCommandModalOpen(true)
    }
    const handleRejectCommandCloseModal = () => {
        setRejectCommandModalOpen(false)
    }

    let totalAchievement = 0;
    const navigate = useNavigate()



    const [loading, setLoading] = useState(false)
    const handleSubmit = async () => {
        if (!comments && !reviewerScore) {
            toast.error("Reviewer PMS Score and Comments is required")
            return

        }

        if (!comments) {
            toast.error("Comments is required")
            return

        } else if (!reviewerScore) {
            toast.error("Reviwer PMS score is required")
            return

        }
        setLoading(true)
        console.log('Submitted Appraisal Data:', appraisalData?.kra_kpi_questions);
        console.log('Submitted Appraisal Data:', typeof (appraisalData));


        console.log('Uploaded Files:', uploadedFiles);
        console.log('Assessee Comments:', comments);



        const data1 = {
            data: {

                reviewer_comment: comments,
                reviewer_rating: getRating(Number(reviewerScore)),
                reviewer_pms_score: reviewerScore,




            },
            method: "put",
            apiName: `submitReviewerEvaluation/${getKraKpiAppraisalForm?.data?.kra_kpi_answer_id}`
        };
        const responseData = await dispatch(actions.SUBMITREVIEWEREVALUATION(data1));

        if (responseData?.payload?.message === "Reviewer evaluation submitted successfully.") {
            setLoading(false)
            toast.success("Reviewer evaluation submitted successfully.")
            setTimeout(() => {
                navigate("/employee/departmentappraisal")
            }, 2000)

        } else {
            setLoading(false)
            toast.error(responseData?.payload?.message)
        }


    };


    const responseShowData = {
        maganerReviewerRatingShow: true,


    }

    // const { krakpiid_employeeid_appraisalyearid } = useParams()
    // console.log(krakpiid_employeeid_appraisalyearid, "krakpiid_employeeid_appraisalyearid")
    // // const number = 111;
    // const digits = krakpiid_employeeid_appraisalyearid.toString().split('').map(Number); // [1, 1, 1]
    // console.log(digits, "digits");
    const location = useLocation();
    const { kra_kpi_id, employeeId, appraisalyearid } = location.state || {};

    const dispatch = useDispatch()


    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {
                    employee_id: employeeId,
                    kra_kpi_id: kra_kpi_id,
                    appraisal_year_id: appraisalyearid
                },
                method: "post",
                apiName: `getKraKpiAppraisalForm`
            };
            const responseData = await dispatch(actions.GETKRAKPIAPPRAISALFORM(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "getEmployeeKraKpiByAppraisalForm get successfully.") {

                setUploadedFiles(responseData?.payload?.data?.employee_document)
                // setAppraisalData(responseData?.payload?.data)
                const rawData = responseData?.payload?.data
                setResponseApiData(rawData)

                console.log(rawData, "raaaaaaaa")

                const kraKpiId = `KRAKPI${rawData?.kra_kpi_name?.replace(/\s+/g, "")}${rawData?.appraisal_year?.split("-")[1]}`;
                // const kraKpiId = rawData?.appraisal_current_status === "employee evaluation completed" ? `KRAKPI${responseKKraKpiNameData?.payload?.data?.kra_kpi_name?.replace(/\s+/g, "")}${responseAppraisaYearData?.payload?.data?.appraisal_year?.split("-")[1]}` : `KRAKPI${rawData?.kra_kpi_name?.replace(/\s+/g, "")}${rawData?.appraisal_year?.split("-")[1]}`;

                console.log(kraKpiId, "12222")


                console.log(rawData?.appraisal_current_status !== "not started" ? rawData?.kra_kpi_answers : rawData?.kra_kpi_questions, "rawData")

                const sections = (
                    rawData?.appraisal_current_status !== "not started"
                        ? rawData?.kra_kpi_answers
                        : rawData?.kra_kpi_questions
                ) ?? [];
                console.log(sections, "sectionss")
                const mappedSections = sections?.map(
                    (kraValue, kraKey) => ({

                        kraId: `${kraKpiId}_${`KRA_0${kraKey + 1}`}`,
                        // const kraId = `${kraKpiId}`;

                        kratitle: kraValue?.[`KRA_0${kraKey + 1}`]?.Parameter,
                        weight: kraValue?.[`KRA_0${kraKey + 1}`]?.Weightage,
                        TotalAchievement: kraValue?.[`KRA_0${kraKey + 1}`]?.TotalAchievement,



                        kpis: kraValue?.[`KRA_0${kraKey + 1}`]?.KPIs?.map((kpiValue, kpiKey) => ({
                            kpiId: `${kraKpiId}_${`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`}`,
                            parameter: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Parameter,
                            weight: String(kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Weightage),
                            achievementPercentage: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.achievementPercentage,
                            Achievement: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Achievement
                        }))


                    }))
                console.log(mappedSections, "sectionssectionssections")
                setQuestionSectionData(mappedSections)
            }


        }
        fetchData()

    }, [])

    const employeeDetails = [
        { label: 'Employee Name', value: getKraKpiAppraisalForm?.data?.employee_name || "--" },
        { label: 'Employee Code', value: getKraKpiAppraisalForm?.data?.employee_code || "--" },
        { label: 'Reporting Manager', value: getKraKpiAppraisalForm?.data?.reporting_manager_name || "--" },
        { label: 'Reviewer Name', value: getKraKpiAppraisalForm?.data?.reviewer_name || "--" },
        { label: 'Department', value: getKraKpiAppraisalForm?.data?.department_name || "--" },
        { label: 'Sub Department', value: getKraKpiAppraisalForm?.data?.sub_department_name || "--" },

        { label: 'Designation', value: getKraKpiAppraisalForm?.data?.designation_name || "--" },

        { label: 'KRA_KPI_ID', value: `KRAKPI${getKraKpiAppraisalForm?.data?.kra_kpi_name?.replace(/\s+/g, "")}${getKraKpiAppraisalForm?.data?.appraisal_year?.split("-")[1]}` || "--" },
        { label: 'DOJ', value: getKraKpiAppraisalForm?.data?.date_of_joining || "--" },
    ];

    return (
        <Box>
            {loading && <FullPageLoader />}
            {/* Header and employee details */}
            <Box sx={{ background: "white", p: 3 }}>
                <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px", mb: 4 }}>
                    PERFORMANCE OF THE YEAR {getKraKpiAppraisalForm?.data?.appraisal_year}
                </Typography>
                <Grid container spacing={4}>
                    {employeeDetails.map((data, idx) => (
                        <Grid key={idx} size={{ xs: 12, md: 6 }}>
                            <Typography variant='subtitle2' sx={{ color: "gray" }}>
                                {data.label}: {data.value}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {/* Appraisal Form */}
            <Box sx={{ mt: 4 }}>
                <AppraisalFormComponent onDataChange={setAppraisalData}
                    questionSectionData={questionSectionData} getKraKpiAppraisalForm={getKraKpiAppraisalForm} />

            </Box>

            {/* Documents */}
            {getKraKpiAppraisalForm?.data?.employee_document?.length > 0 && (


                <Box sx={{ background: "white", p: 3, mt: 4 }}>

                    <Typography variant='subtitle2' sx={{ fontSize: "18px", mb: 4, color: "black" }}>
                        Documents
                    </Typography>
                    <FileUploadWithPreview setUploadedFiles={setUploadedFiles} uploadedFiles={uploadedFiles} getKraKpiAppraisalForm={getKraKpiAppraisalForm} />
                </Box>
            )}
            {/* Pms score */}
            {/* {getKraKpiAppraisalForm?.data?.pms_score_show && ( */}
            <Box sx={{ background: "white", p: 3, mt: 4 }}>
                <Typography variant='subtitle2' sx={{ fontSize: "18px", mb: 4, color: "black" }}>
                    Overview Rating
                </Typography>

                <>
                    <DepartmentPMSRating responseShowData={getKraKpiAppraisalForm} getKraKpiAppraisalForm={getKraKpiAppraisalForm} reviewerScore={reviewerScore} setReviewerScore={setReviewerScore} />
                    <Box>
                        <RatingTable />
                    </Box>
                </>

            </Box>
            {/* )}/ */}



            {/* Comments */}
            <Box sx={{ background: "white", p: 3, mt: 4 }}>
                <Typography variant='subtitle2' sx={{ fontSize: "18px", mb: 4, color: "black" }}>
                    Comments
                </Typography>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 8 }}>
                        <label>
                            <Typography variant="subtitle1" sx={{ color: "gray", fontSize: "15px", mb: 1 }}>
                                Assessee Comments
                            </Typography>
                        </label>
                        <TextField
                            fullWidth
                            size="small"
                            multiline
                            rows={4}
                            value={getKraKpiAppraisalForm?.data?.employee_comment || comments}
                            sx={{ background: getKraKpiAppraisalForm?.data?.appraisal_current_status !== "not started" && "#f0f0f0" }}
                            disabled={
                                getKraKpiAppraisalForm?.data?.appraisal_current_status !== "not started"

                            }
                        // onChange={(e) => setComments(e.target.value)}
                        />
                    </Grid>
                    <>
                        <Grid size={{ xs: 12, md: 8 }}>
                            <label>
                                <Typography variant="subtitle1" sx={{ color: "gray", fontSize: "15px", mb: 1 }}>
                                    Manager Comments
                                </Typography>
                            </label>
                            <TextField
                                fullWidth
                                size="small"
                                multiline
                                onChange={(e) => setComments(e.target.value)}
                                // disabled={getKraKpiAppraisalForm?.data?.appraisal_current_status === "manager evaluation completed" || getKraKpiAppraisalForm?.data?.appraisal_current_status === "manager evaluation ccompleted" || getKraKpiAppraisalForm?.data?.manager_appraisal_score_editable}
                                rows={4}
                                disabled
                                // value={comments}/
                                value={getKraKpiAppraisalForm?.data?.manager_comment}

                                sx={{ background: "#f0f0f0" }}


                            />
                        </Grid>
                        {
                            !getKraKpiAppraisalForm?.data?.manager_appraisal_score_editable && (


                                <Grid size={{ xs: 12, md: 8 }}>
                                    <label>
                                        <Typography variant="subtitle1" sx={{ color: "gray", fontSize: "15px", mb: 1 }}>
                                            Reviewer Comments
                                        </Typography>
                                    </label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        // disabled
                                        multiline
                                        rows={4}
                                        // value={comments}
                                        onChange={(e) => setComments(e.target.value)}
                                        // sx={{ background: "#f0f0f0" }}
                                        value={getKraKpiAppraisalForm?.data?.reviewer_comment || comments}

                                        // sx={{ background: "#f0f0f0" }}
                                        disabled={getKraKpiAppraisalForm?.data?.appraisal_current_status === "reviewer evaluation completed"}
                                        sx={{ background: getKraKpiAppraisalForm?.data?.appraisal_current_status === "reviewer evaluation completed" && "#f0f0f0" }}



                                    />
                                </Grid>
                            )}
                    </>
                </Grid>
                {getKraKpiAppraisalForm?.data?.reviewer_reject_comment && (
                    <>
                        <Typography variant='subtitle2' sx={{ mt: 2, color: "black" }}>
                            Reviewer Reject Comment
                        </Typography>
                        <Typography variant='subtitle1' sx={{ color: "gray", ml: 2 }}>
                            {getKraKpiAppraisalForm?.data?.reviewer_reject_comment}
                        </Typography>


                    </>
                )}
                {
                    getKraKpiAppraisalForm?.data?.appraisal_current_status === "manager evaluation completed" &&
                    <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                        <Button onClick={handleRejectCommandOpenModal} variant="contained" sx={{ mt: 2, background: "var(--main-color)", textTransform: "none", mr: 2, px: 2, backgroundColor: "#ec2c2d" }}>
                            Reject
                        </Button>

                        <Button onClick={handleSubmit} variant="contained" sx={{ mt: 2, background: "var(--main-color)", textTransform: "none" }}>
                            Submit
                        </Button>
                    </Box>
                }
                {/* <Box sx={{ background: "white", mt: 4 }}>

                    <AppraisalHistory />


                </Box> */}

            </Box>
            <ToastContainer
                position="top-right" // or "top-center", "bottom-left", etc.
                autoClose={1500} // Auto close duration in ms
                hideProgressBar={false} // Hide or show progress bar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />

            <RejectCommendModal

                rejectApiCallName='reviewer'
                open={isRejectCommandModalOpen}
                onClose={handleRejectCommandCloseModal}
            />
        </Box >
    );
};

export default DepartmentAppraisalForm;
